import MyHST from './myhst_landing';
export default function App() {
  return <MyHST />;
}
